<rt-candidate-sharing-assignments
  [heading]="state.heading || ('app.candidate.share_assignments.heading' | translate)"
  [subheading]="state.subheading || ('app.candidate.share_assignments.subheading' | translate)"
  [submitText]="state.submitText || ('app.common.save' | translate)"
  [assignments]="state.assignments"
  [containers]="state.activeContainers"
  [isLoading]="state.isLoading"
  [isLoaded]="state.loaded"
  [disableSubmitIfNoAssignments]="state.deleteMode"
  (cancelClick)="cancelClick()"
  (submitClick)="submitClick($event)"
/>
